export const state = {
  version: 1,
  themeMode: 0,
  theme: {
    id: 1,
    url: "light/full/0.jpg",
    small: "light/small/0.png",
    mode: 0
  },
}